<template>
  <div class="a">
    <!-- 头部 -->
    <titled :num="1"></titled>
    <span class="apphome">
      <el-tabs v-model="activeName" type="border-card" style="width: 100%;" @tab-click="handleClick">
        <el-tab-pane label="趋势" name="first">
          <div class="search">
            <span>
              <div class="name">时间段</div>
              <el-select v-model="value" placeholder="请选择" @change="valueFn">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </span>
            <span style="margin-left:20px">
              <div class="name">变量类型</div>
              <el-select v-model="variableValue" placeholder="请选择" @change="variableValueFn">
                <el-option v-for="item in variableOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </span>
            <span style="margin-left: 30px;">
              <div class="name"></div>
              <div class="p">
                <el-button type="primary" @click="getList">查询</el-button>
              </div>
            </span>

          </div>
          <div class="echart">
            <vchart style="height: 380px;width:100%;" ref='vchart'></vchart>
          </div>
        </el-tab-pane>
        <el-tab-pane label="电流温度曲线" name="second">
          <div class="search">
            <span>
              <div class="name">时间段</div>
              <el-select v-model="value" placeholder="请选择" @change="valueFn">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </span>
          </div>
          <div class="echart">
            <vchart style="height: 380px;width:168vh ;" ref='vchart2'></vchart>
          </div>
        </el-tab-pane>
      </el-tabs>
    </span>
  </div>
</template>
<script>

  import titled from '@/components/module/titled/titled.vue';
  import vchart from '@/components/module/chart/vchart.vue'
  import { findCurve } from "../../api/maintain";
  export default {
    components: {
      titled,
      vchart
    },
    data() {

      return {
        data1: [100, 230, 224, 218, 135, 147, 260, 100, 230, 224, 218, 135, 147, 260],
        data2: [150, 230, 224, 218, 135, 147, 260, 150, 230, 224, 218, 135, 147, 260],
        nowDevice: {},//当前设备
        dayOption: {
          legend: {
            right: '1%',
          },
          grid: {
            // 距离 上右下左 的距离
            left: '5%',
            right: '5%',
            bottom: '8%',
            top: '12%',
            containLabel: true,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            name: '电流（A）温度（℃）',
            nameTextStyle: {
              fontSize: 15,
              padding: [0, 0, 0, 70],
              color: '#999',
              rich: {
                a: {
                  // 没有设置 `lineHeight`，则 `lineHeight` 为 56
                }
              }
            },
            axisLine: {
              show: true,
            },
            type: 'value'
          },
          series: [
            {
              name: '电流',
              data: [100, 230, 224, 218, 135, 147, 260, 100, 230, 224, 218, 135, 147, 260],
              type: 'line'
            },

          ]
        },
        activeName: 'first',
        options: [{
          value: 'DAY',
          label: '日'
        }, {
          value: 'MON',
          label: '月'
        }, {
          value: 'YEAR',
          label: '年'
        }],
        variableOption: [{
          value: 'ELECTRICITY',
          label: '电流'
        }, {
          value: 'TEMPERATURE',
          label: '温度'
        }],
        value: 'DAY',
        variableValue: "ELECTRICITY",
        dayData: [],
        monthData: [],
        yearData: [],
        dayOption2: {
          legend: {
            right: '1%',
          },
          grid: {
            // 距离 上右下左 的距离
            left: '5%',
            right: '5%',
            bottom: '8%',
            top: '12%',
            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            name: '电流（A）温度（℃）',
            nameTextStyle: {
              fontSize: 15,
              padding: [0, 0, 0, 70],
              color: '#999',
              rich: {
                a: {
                  // 没有设置 `lineHeight`，则 `lineHeight` 为 56
                }
              }
            },
            axisLine: {
              show: true,
            },
            type: 'value'
          },
          series: [
            {
              name: '电流',
              data: [100, 230, 224, 218, 135, 147, 260, 100, 230, 224, 218, 135, 147, 260],
              type: 'line'
            },
            {
              name: '温度',
              data: [150, 230, 224, 218, 135, 147, 260, 150, 230, 224, 218, 135, 147, 260],
              type: 'line'
            }
          ]
        },

      }
    },
    computed: {
      setDeviceItem() {
        return this.$store.cacheStore.state.setDevice
      },
    },
    watch: {
      setDeviceItem: function (val) {
        this.nowDevice = val
        this.getList()
      },

    },

    mounted() {
      for (let i = 1; i <= 31; i++) {
        if (i <= 24) {
          this.dayData.push(i > 9 ? i + ':00' : '0' + i + ':00')
        }
        if (i <= 12) {
          this.yearData.push(i + '月')
        }
        this.monthData.push(i + '日');
      }
      this.dayOption.xAxis.data = this.dayData;
      this.dayOption2.xAxis.data = this.dayData;
      this.$refs.vchart.setData(this.dayOption, true);
    },
    methods: {
      valueFn(v) {
        if (v == "DAY") {
          this.dayOption.xAxis.data = this.dayData;
          this.dayOption2.xAxis.data = this.dayData;
        }
        if (v == "MON") {
          this.dayOption.xAxis.data = this.monthData;
          this.dayOption2.xAxis.data = this.monthData;
        }
        if (v == "YEAR") {
          this.dayOption.xAxis.data = this.yearData;
          this.dayOption2.xAxis.data = this.yearData;
        }
        if (this.$refs.vchart) {
          this.$refs.vchart.setData(this.dayOption, true);
        }
        if (this.$refs.vchart2) {
          this.$refs.vchart2.setData(this.dayOption2, true);
        }
      },
      variableValueFn(v) {
        if (v != 'TEMPERATURE') {
          this.dayOption.color = '#ffca28';
          this.dayOption.series = [{
            name: '电流',
            data: this.data1,
            type: 'line'
          }]
        } else {
          this.dayOption.color = '#1dd76c';
          this.dayOption.series = [{
            name: '温度',
            data: this.data2,
            type: 'line'
          }]
        }
        this.$refs.vchart.setData(this.dayOption, true);
      },
      handleClick(tab, event) {
        if (this.$refs.vchart2) {
          this.$refs.vchart2.setData(this.dayOption2, true);
        }
      },
      getMath(index = 10) {
        return Math.round(Math.random() * index);
      },
      //获取数据
      getList() {
        this.data1 = [];
        for (let i = 0; i < 31; i++) {
          this.data1.push(this.getMath(250))
          this.data2.push(this.getMath(250))
        }
        this.dayOption.series[0].data = this.data1;
        this.dayOption2.series[0].data = this.data1;
        this.dayOption2.series[1].data = this.data2;
        if (this.$refs.vchart) {
          this.$refs.vchart.setData(this.dayOption, true);
        }
        if (this.$refs.vchart2) {
          this.$refs.vchart2.setData(this.dayOption2, true);
        }

      },



    }
  };
</script>

<style lang="scss" scoped>
  .apphome .echart {
    width: 100%;
  }

  .apphome .search {
    display: flex;
  }

  .apphome .search .name {
    height: 30px;
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
    color: #999;
    margin-bottom: 5px;
  }

  .apphome {
    padding: 15px;
    /* overflow-x: scroll; */
    display: flex;
    margin-top: 1rem;
  }
</style>